import Vue from 'vue'
import Router from 'vue-router'


const Login = r => require.ensure([], () => r(require('@/views/Login/index.vue')), 'Login')//登陆
const setEmail = r => require.ensure([], () => r(require('@/views/CommonResiger/setEmail.vue')), 'setEmail')//注册邮箱
const emailTips = r => require.ensure([], () => r(require('@/views/CommonResiger/emailTips.vue')), 'emailTips')//发送邮箱完，提示关闭
const telTips = r => require.ensure([], () => r(require('@/views/CommonResiger/emailTips.vue')), 'telTips')
// const authenticationCode = r => require.ensure([], () => r(require('@/views/CommonResiger/authenticationCode.vue')), 'authenticationCode')//认证代码
const applyTypeChoose = r => require.ensure([], () => r(require('@/views/CommonResiger/applyTypeChoose')), 'applyTypeChoose')//申请类型选择
const transferPage = r => require.ensure([], () => r(require('@/views/CommonResiger/transferPage')), 'transferPage')//中转页面
// const setEmail_byorther = r => require.ensure([], () => r(require('@/views/CommonResiger/setEmail_byorther.vue')), 'setEmail_byorther')//注册邮箱
const z1100 = r => require.ensure([], () => r(require('@/views/CommonResiger/z1100')), 'z1100')//メンテナンス画面
const z1200 = r => require.ensure([], () => r(require('@/views/CommonResiger/z1200')), 'z1200')//システムエラー（予期せぬエラー）
const z1201 = r => require.ensure([], () => r(require('@/views/CommonResiger/z1201')), 'z1201')//NotFound（404エラー）


// 个人
// 基本信息
const nameBirthdaySex = r => require.ensure([], () => r(require('@/views/PersonalResiger/BasicInfo/nameBirthdaySex')), 'nameBirthdaySex')//信息填写
//const underAgeInfo = r => require.ensure([], () => r(require('@/views/PersonalResiger/BasicInfo/underAgeInfo.vue')), 'underAgeInfo')//未成年信息填写
//地址
const nationalty = r => require.ensure([], () => r(require('@/views/PersonalResiger/AddressInfo/nationalty')), 'nationalty')//国籍
const address = r => require.ensure([], () => r(require('@/views/PersonalResiger/AddressInfo/address')), 'address')//住所
// const IsSameNowAddress = r => require.ensure([], () => r(require('@/views/PersonalResiger/AddressInfo/IsSameNowAddress.vue')), 'IsSameNowAddress')//是否与现在地址相同
// const nowAddress = r => require.ensure([], () => r(require('@/views/PersonalResiger/AddressInfo/nowAddress.vue')), 'nowAddress')//住所

//电话
const tel = r => require.ensure([], () => r(require('@/views/PersonalResiger/TelInfo/tel')), 'tel')//電話番号

//金融机构
const financialBank = r => require.ensure([], () => r(require('@/views/PersonalResiger/Financial/bank.vue')), 'financialBank')

//职业
const occupationType = r => require.ensure([], () => r(require('@/views/PersonalResiger/Occupation/occupationType')), 'occupationType')//勤務先情報
const employmentName = r => require.ensure([], () => r(require('@/views/PersonalResiger/Occupation/employmentName')), 'employmentName')//勤務先名
//const employmentAddress = r => require.ensure([], () => r(require('@/views/PersonalResiger/Occupation/employmentAddress')), 'employmentAddress')//勤務先住所
//const schoolName = r => require.ensure([], () => r(require('@/views/PersonalResiger/Occupation/schoolName.vue')), 'schoolName')//勤務先住所
//const employmentTel = r => require.ensure([], () => r(require('@/views/PersonalResiger/Occupation/employmentTel')), 'employmentTel')//勤務先電話番号
// 内部者フラグ
// const insiderFlg = r => require.ensure([], () => r(require('@/views/PersonalResiger/Insider/insiderFlg')), 'insiderFlg')//内部者フラグ
const fundInsiderFlg = r => require.ensure([], () => r(require('@/views/PersonalResiger/Insider/fundInsiderFlg')), 'fundInsiderFlg')//基金内部者フラグ
//const insiderSeparation = r => require.ensure([], () => r(require('@/views/PersonalResiger/Insider/insiderSeparation')), 'insiderSeparation')//内部者区分
//const insiderInfo = r => require.ensure([], () => r(require('@/views/PersonalResiger/Insider/insiderInfo')), 'insiderInfo')//内部者情報
//const insiderAdd = r => require.ensure([], () => r(require('@/views/PersonalResiger/Insider/insiderAdd')), 'insiderAdd')//内部者の追加

//动机
const questionMotiveType = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/questionMotiveType')), 'questionMotiveType')//申込動機区分
const purpose = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/purpose')), 'purpose')//投資の目的
const annualIncome = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/annualIncome')), 'annualIncome')//年収
const revenue = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/annualIncome')), 'revenue')//主な収入
const financialAssts = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/annualIncome')), 'financialAssts')//金融の資産状態
const asstsType = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/asstsType')), 'asstsType')//投資資産の内容
const experienceStock = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/annualIncome')), 'experienceStock')//投資経験 株式
const experienceDerivative = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/experienceDerivative')), 'experienceDerivative')//投資経験 デリバティブ
const experienceFund = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/annualIncome')), 'experienceFund')//投資経験 投信
const desiredInvestmentType = r => require.ensure([], () => r(require('@/views/PersonalResiger/Invest/desiredInvestmentType')), 'desiredInvestmentType')//興味のある投資商品

//确认书
const electronic = r => require.ensure([], () => r(require('@/views/PersonalResiger/Confirm/electronic.vue')), 'electronic')//电子交互
const personalInfo = r => require.ensure([], () => r(require('@/views/PersonalResiger/Confirm/personalInfo.vue')), 'personalInfo')//個人情報保護方針
const antisocialFlg = r => require.ensure([], () => r(require('@/views/PersonalResiger/Confirm/antisocialFlg')), 'antisocialFlg')//反社確認
const regulation = r => require.ensure([], () => r(require('@/views/PersonalResiger/Confirm/regulation')), 'regulation')//約款・規定集 締結前交付書面
// const unqualified = r => require.ensure([], () => r(require('@/views/PersonalResiger/Confirm/unqualified')), 'unqualified')//不符合条件的
const submitconfirm = r => require.ensure([], () => r(require('@/views/PersonalResiger/Confirm/submitconfirm.vue')), 'submitconfirm')

//登录密码
const loginPassword = r => require.ensure([], () => r(require('@/views/PersonalResiger/BasicInfo/loginPassword')), 'loginPassword')//ログインパスワード
const confirmInfo = r => require.ensure([], () => r(require('@/views/PersonalResiger/BasicInfo/confirmInfo')), 'confirmInfo')//入力情報確認
// const identificationGuide = r => require.ensure([], () => r(require('@/views/PersonalResiger/Confirm/identificationGuide')), 'identificationGuide')//マイナンバーと本人確認書類の提出案内

//确认书类
const documentVerifySetEmail = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/documentVerifySetEmail')), 'documentVerifySetEmail')//確認書類メアド認証
const identityDocumentsType = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/identityDocumentsType')), 'identityDocumentsType')//本人確認書類の種類を選択
//const myNumber = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/myNumber')), 'myNumber')//マイナンバーの入力
const myNumberUpload = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/myNumberUpload')), 'myNumberUpload')//マイナンバーアップロード
//const documentUpload = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/documentUpload.vue')), 'documentUpload')//続柄確認書類をアップロードしてください
const onlineConfirm = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/OnlineConfirm.vue')), 'onlineConfirm')//ekyc
const SelfConfirm = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/SelfConfirm.vue')), 'SelfConfirm')//over
const RegisterIndex = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/index.vue')), 'Index')
const Over = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/over.vue')), 'Over')
// 法人

// 法人部分
const corporateNameNumber = r => require.ensure([], () => r(require('@/views/Resiger/BasicInfo/corporateNameNumber')), 'corporateNameNumber')//法人名番号
const corporateListType = r => require.ensure([], () => r(require('@/views/Resiger/BasicInfo/corporateListType')), 'corporateListType')//上場区分法人区分
const corporateAddress = r => require.ensure([], () => r(require('@/views/Resiger/BasicInfo/corporateAddress')), 'corporateAddress')//法人所在地
const representativeTel = r => require.ensure([], () => r(require('@/views/Resiger/Represent/representativeTel')), 'representativeTel')//代表者電話番号
const businessContent = r => require.ensure([], () => r(require('@/views/Resiger/BasicInfo/businessContent')), 'businessContent')//事業内容

const capitalTaxType = r => require.ensure([], () => r(require('@/views/Resiger/BasicInfo/capitalTaxType')), 'capitalTaxType')//資本金
const dateOfEstablishment = r => require.ensure([], () => r(require('@/views/Resiger/BasicInfo/dateOfEstablishment')), 'dateOfEstablishment')//設立年月日本決算日
const representativeInfo = r => require.ensure([], () => r(require('@/views/Resiger/Represent/representativeInfo')), 'representativeInfo')//代表者情報

//取引责任人
const transactionManager = r => require.ensure([], () => r(require('@/views/Resiger/Transaction/transactionManager')), 'transactionManager')//取引責任者情報
const listedCorporationFlg = r => require.ensure([], () => r(require('@/views/Resiger/Transaction/listedCorporationFlg')), 'listedCorporationFlg')//上場企業への該当
const specifiedCorporationFlg = r => require.ensure([], () => r(require('@/views/Resiger/Transaction/specifiedCorporationFlg')), 'specifiedCorporationFlg')//特定法人への該当性
const rulerInfo = r => require.ensure([], () => r(require('@/views/Resiger/Transaction/rulerInfo')), 'rulerInfo')//実質的支配者の情報
// const corporateInsiderFlg = r => require.ensure([], () => r(require('@/views/Resiger/Transaction/corporateInsiderFlg')), 'corporateInsiderFlg')//法人内部者フラグ
const corporateFundInsiderFlg = r => require.ensure([], () => r(require('@/views/Resiger/Transaction/corporateFundInsiderFlg')), 'corporateFundInsiderFlg')//法人基金内部者フラグ
const corporateWithdrawAccount = r => require.ensure([], () => r(require('@/views/Resiger/Bank/corporateWithdrawAccount')), 'corporateWithdrawAccount')//出金先の金融機関

//动机
const corporateQuestionMotiveType = r => require.ensure([], () => r(require('@/views/Resiger/Invest/corporateQuestionMotiveType')), 'corporateQuestionMotiveType')//お申し込み動機
const corporatePurpose = r => require.ensure([], () => r(require('@/views/Resiger/Invest/corporatePurpose')), 'corporatePurpose')//投資の目的
const corporateFinancialAssts = r => require.ensure([], () => r(require('@/views/Resiger/Invest/corporateFinancialAssts')), 'corporateFinancialAssts')//金融資産状態
// const corporateAsstsType = r => require.ensure([], () => r(require('@/views/Resiger/Invest/corporateAsstsType')), 'corporateAsstsType')//投資資金の内容
const corporateExperienceStock = r => require.ensure([], () => r(require('@/views/Resiger/Invest/corporateExperienceStock')), 'corporateExperienceStock')//投資経験 株式
const corporateExperienceDerivative = r => require.ensure([], () => r(require('@/views/Resiger/Invest/corporateExperienceDerivative')), 'corporateExperienceDerivative')//投資経験 デリバティブ
const corporateExperienceFund = r => require.ensure([], () => r(require('@/views/Resiger/Invest/corporateExperienceFund')), 'corporateExperienceFund')//投資経験 投信
const corporateDesiredInvestmentType = r => require.ensure([], () => r(require('@/views/Resiger/Invest/corporateDesiredInvestmentType')), 'corporateDesiredInvestmentType')//興味のある投資商品

// 同意事项
const corporateElectronicDelivery = r => require.ensure([], () => r(require('@/views/Resiger/Comfrim/corporateElectronicDelivery')), 'corporateElectronicDelivery')//電子交付等に関する説明書をご確認ください
const corporatePersonalInfo = r => require.ensure([], () => r(require('@/views/Resiger/Comfrim/corporatePersonalInfo')), 'corporatePersonalInfo')//個人情報保護方針
const corporateAntisocialFlg = r => require.ensure([], () => r(require('@/views/Resiger/Comfrim/corporateAntisocialFlg')), 'corporateAntisocialFlg')//反社確認
const corporateRegulation = r => require.ensure([], () => r(require('@/views/Resiger/Comfrim/corporateRegulation')), 'corporateRegulation')//約款・規定集 締結前交付書面
const foreignCountryCompany = r => require.ensure([], () => r(require('@/views/Resiger/Comfrim/foreignCountryCompany')), 'foreignCountryCompany')//法人在籍国

const corporateLoginPassword = r => require.ensure([], () => r(require('@/views/Resiger/Comfrim/corporateLoginPassword')), 'corporateLoginPassword')//ログインパスワード

const corporateConfirmInfo = r => require.ensure([], () => r(require('@/views/Resiger/Comfrim/corporateConfirmInfo')), 'corporateConfirmInfo')//入力情報確認
const corporateidentificationGuide = r => require.ensure([], () => r(require('@/views/Resiger/Comfrim/identificationGuide')), 'identificationGuide')//マイナンバーと本人確認書類の提出案内

// 本人确认书
// const corporateCertificateUpload = r => require.ensure([], () => r(require('@/views/Resiger/CorporateComfrim/corporateCertificateUpload')), 'corporateCertificateUpload')//法人確認証明書
const representativeIdentityDocumentsType = r => require.ensure([], () => r(require('@/views/Resiger/CorporateComfrim/representativeIdentityDocumentsType')), 'representativeIdentityDocumentsType')//代表者の本人確認書類の選択
const representativeIdentityDocumentsUpload = r => require.ensure([], () => r(require('@/views/Resiger/CorporateComfrim/representativeIdentityDocumentsUpload')), 'representativeIdentityDocumentsUpload')//代表者の本人確認書類のアップロード
const transactionManagerIdentityDocumentsType = r => require.ensure([], () => r(require('@/views/Resiger/CorporateComfrim/transaction/transactionManagerIdentityDocumentsType')), 'transactionManagerIdentityDocumentsType')//取引責任者の本人確認書類の選択
const transactionManagerIdentityDocumentsUpload = r => require.ensure([], () => r(require('@/views/Resiger/CorporateComfrim/transaction/transactionManagerIdentityDocumentsUpload')), 'transactionManagerIdentityDocumentsUpload')//取引責任者の本人確認書類のアップロード
// const rulerIdentityDocumentsType = r => require.ensure([], () => r(require('@/views/Resiger/CorporateComfrim/transaction/rulerIdentityDocumentsType')), 'rulerIdentityDocumentsType')//実質的支配者の本人確認書類の選択
const rulerIdentityDocumentsUpload = r => require.ensure([], () => r(require('@/views/Resiger/CorporateComfrim/transaction/rulerIdentityDocumentsUpload')), 'rulerIdentityDocumentsUpload')//実質的支配者の本人確認書類のアップロード
// const documentsUploadDone = r => require.ensure([], () => r(require('@/views/Resiger/corporate/documentsUploadDone')), 'documentsUploadDone')//本人確認書類のアップロード完了

const subpageflow = r => require.ensure([], () => r(require('@/views/Resiger/subpageflow')), 'subpageflow')//登録の流れ
const subpageflowcorporate = r => require.ensure([], () => r(require('@/views/Resiger/subpageflowcorporate')), 'subpageflowcorporate')//登録の流れ法人用
const subpageinsider = r => require.ensure([], () => r(require('@/views/Resiger/subpageinsider')), 'subpageinsider')//インサイダー取引について
const subpagetips = r => require.ensure([], () => r(require('@/views/Resiger/subpagetips')), 'subpagetips')//口座開設Tips
const subpagedocument = r => require.ensure([], () => r(require('@/views/Resiger/subpagedocument')), 'subpagedocument')//確認書類について（個人）
const subpagetokutei = r => require.ensure([], () => r(require('@/views/Resiger/subpagetokutei')), 'subpagetokutei')//特定法人について（法人）
const peps = r => require.ensure([], () => r(require('@/views/Resiger/peps')), 'peps')//外国PEPsについて




//再提出
const certifyEmail = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/documentVerifySetEmail.vue')), 'documentVerifySetEmail')

// const resetEmail = r => require.ensure([], () => r(require('@/views/CommonResiger/resetEmail.vue')), 'resetEmail')
// const resetIndex = r => require.ensure([], () => r(require('@/views/ResetResiger/resetIndex.vue')), 'resetIndex')
const resetConfirmInfo = r => require.ensure([], () => r(require('@/views/PersonalResiger/BasicInfo/confirmInfo')), 'resetConfirmInfo')
const resetNameBirthdaySex = r => require.ensure([], () => r(require('@/views/PersonalResiger/BasicInfo/nameBirthdaySex')), 'resetNameBirthdaySex')
// const resetNationalty = r => require.ensure([], () => r(require('@/views/ResetResiger/Individual/nationalty.vue')), 'resetNationalty')
const resetTel = r => require.ensure([], () => r(require('@/views/PersonalResiger/TelInfo/tel')), 'resetTel')
const resetAddress = r => require.ensure([], () => r(require('@/views/PersonalResiger/AddressInfo/address')), 'resetAddress')
// const resetIdentityType = r => require.ensure([], () => r(require('@/views/ResetResiger/Individual/resetIdentityType.vue')), 'resetIdentityType')
// const resetMyNumber = r => require.ensure([], () => r(require('@/views/ResetResiger/Individual/myNumber.vue')), 'resetMyNumber')
// const resetMyNumberUpload = r => require.ensure([], () => r(require('@/views/ResetResiger/Individual/myNumberUpload.vue')), 'resetMyNumberUpload')
// const resetOnlineConfirm = r => require.ensure([], () => r(require('@/views/ResetResiger/Individual/OnlineConfirm.vue')), 'resetOnlineConfirm')//ekyc
// const resetSelfConfirm = r => require.ensure([], () => r(require('@/views/PersonalConfirmResiger/SelfConfirm.vue')), 'resetSelfConfirm')//over

//【法人】再提出
// const corporateResetConfirmInfo = r => require.ensure([], () => r(require('@/views/Resiger/Individual/resetConfirmInfo.vue')), 'corporateResetConfirmInfo')//确认信息界面
// const resetCertificateUpload = r => require.ensure([], () => r(require('@/views/Resiger/Individual/resetCertificateUpload.vue')), 'resetCertificateUpload')
const resetRepresentType = r => require.ensure([], () => r(require('@/views/Resiger/Individual/resetRepresentType.vue')), 'resetRepresentType')
const resetRepresentUpload = r => require.ensure([], () => r(require('@/views/Resiger/Individual/resetRepresentUpload.vue')), 'resetRepresentUpload')
const resetTransactionManagerType = r => require.ensure([], () => r(require('@/views/Resiger/Individual/resetTransactionManagerType.vue')), 'resetTransactionManagerType')
const resetTransactionManagerUpload = r => require.ensure([], () => r(require('@/views/Resiger/Individual/resetTransactionManagerUpload.vue')), 'resetTransactionManagerUpload')
const resetRulerTypeUpload = r => require.ensure([], () => r(require('@/views/Resiger/Individual/resetRulerTypeUpload.vue')), 'resetRulerTypeUpload')



Vue.use(Router)
const $router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Login,
      name: Login
    },
    {
      path: '/Register',
      component: RegisterIndex,
      name: RegisterIndex,
      children: [
        {
          path: 'SelfConfirm',
          component: SelfConfirm,
          name: SelfConfirm
        },
        {
          path: 'Over',
          component: Over,
          name: Over
        },
        {
          path: 'resetOver',
          component: Over,
        }

      ]
    },
    {
      path: '/applyTypeChoose',
      component: applyTypeChoose,
      name: applyTypeChoose,
      meta: { requireAuth: true }
    },
    {
      path: '/transferPage',
      component: transferPage,
      name: transferPage
    },
    {
      path: '/nameBirthdaySex',
      component: nameBirthdaySex,
      name: nameBirthdaySex,
      meta: { requireAuth: true }
    },
//    {
//      path: '/underAgeInfo',
//      component: underAgeInfo,
//      name: underAgeInfo,
//      meta: { requireAuth: true }
//    },
    {
      path: '/setEmail',
      component: setEmail,
      name: setEmail
    },
    // {
    //   path: '/setEmail_byorther',
    //   component: setEmail_byorther,
    //   name: setEmail_byorther
    // },
    {
      path: '/z1100',
      component: z1100,
      name: z1100,
    },
    {
      path: '/z1200',
      component: z1200,
      name: z1200,
    },
    {
      path: '*',
      component: z1201,
      name: z1201,
    },
    {
      path: '/emailTips',
      component: emailTips,
      name: emailTips
    },
    {
      path: '/telTips',
      component: telTips,
      name: telTips
    },
  //  {
  //    path: '/authenticationCode',
  //    component: authenticationCode,
  //    name: authenticationCode
  //  },
    {
      path: '/address',
      component: address,
      name: address,
      meta: { requireAuth: true }
    },
    {
      path: '/tel',
      component: tel,
      name: tel,
      meta: { requireAuth: true }
    },
    {
      path: '/occupationType',
      component: occupationType,
      name: occupationType,
      meta: { requireAuth: true }
    },
    {
      path: '/employmentName',
      component: employmentName,
      name: employmentName,
      meta: { requireAuth: true }
    },
//    {
//      path: '/employmentAddress',
//      component: employmentAddress,
//      name: employmentAddress
//    },
//    {
//      path: '/schoolName',
//      component: schoolName,
//      name: schoolName
//    },
//    {
//      path: '/employmentTel',
//      component: employmentTel,
//      name: employmentTel
//    },
//    {
//      path: '/documentUpload',
//      component: documentUpload,
//      name: documentUpload
//    },
    // {
    //   path: '/insiderFlg',
    //   component: insiderFlg,
    //   name: insiderFlg,
    //   meta: { requireAuth: true }
    // },
    {
      path: '/fundInsiderFlg',
      component: fundInsiderFlg,
      name: fundInsiderFlg,
      meta: { requireAuth: true }
    },
    {
      path: '/onlineConfirm',
      component: onlineConfirm,
      name: onlineConfirm
    },
//    {
//      path: '/insiderSeparation',
//      component: insiderSeparation,
//      name: insiderSeparation
//    },
//    {
//      path: '/insiderInfo',
//      component: insiderInfo,
//      name: insiderInfo
//    },
//    {
//      path: '/insiderAdd',
//      component: insiderAdd,
//      name: 'insiderAdd'
//    },
    {
      path: '/submitconfirm',
      component: submitconfirm,
      name: 'submitconfirm'
    },
    {
      path: '/questionMotiveType',
      component: questionMotiveType,
      name: questionMotiveType,
      meta: { requireAuth: true }
    },
    {
      path: '/purpose',
      component: purpose,
      name: purpose,
      meta: { requireAuth: true }
    },
    {
      path: '/annualIncome',
      component: annualIncome,
      name: 'annualIncome',
      meta: { requireAuth: true }
    },
    {
      path: '/electronic',
      component: electronic,
      name: 'electronic',
      meta: { requireAuth: true }
    },
    {
      path: '/personalInfo',
      component: personalInfo,
      name: 'personalInfo',
      meta: { requireAuth: true }
    },
    {
      path: '/revenue',
      component: revenue,
      name: 'revenue',
      meta: { requireAuth: true }
    },
    {
      path: '/financialAssts',
      component: financialAssts,
      name: financialAssts,
      meta: { requireAuth: true }
    },
    {
      path: '/asstsType',
      component: asstsType,
      name: asstsType,
      meta: { requireAuth: true }
    },
    {
      path: '/experienceStock',
      component: experienceStock,
      name: experienceStock,
      meta: { requireAuth: true }
    },
    {
      path: '/experienceDerivative',
      component: experienceDerivative,
      name: experienceDerivative,
      meta: { requireAuth: true }
    },
    {
      path: '/experienceFund',
      component: experienceFund,
      name: experienceFund,
      meta: { requireAuth: true }
    },
    {
      path: '/desiredInvestmentType',
      component: desiredInvestmentType,
      name: desiredInvestmentType,
      meta: { requireAuth: true }
    },
    {
      path: '/antisocialFlg',
      component: antisocialFlg,
      name: antisocialFlg,
      meta: { requireAuth: true }
    },
    {
      path: '/regulation',
      component: regulation,
      name: regulation,
      meta: { requireAuth: true }
    },
    {
      path: '/loginPassword',
      component: loginPassword,
      name: loginPassword,
      meta: { requireAuth: true }
    },
    {
      path: '/confirmInfo',
      component: confirmInfo,
      name: confirmInfo,
      meta: { requireAuth: true }
    },
    // {
    //   path: '/identificationGuide',
    //   component: identificationGuide,
    //   name: identificationGuide
    // },
    {
      path: '/identityDocumentsType',
      component: identityDocumentsType,
      name: identityDocumentsType
    },
//    {
//      path: '/myNumber',
//      component: myNumber,
//      name: myNumber
//    },
    {
      path: '/myNumberUpload',
      component: myNumberUpload,
      name: myNumberUpload
    },
    {
      path: '/nationalty',
      component: nationalty,
      name: nationalty,
      meta: { requireAuth: true }
    },
    // {
    //   path: '/nowAddress',
    //   component: nowAddress,
    //   name: nowAddress
    // },
    // {
    //   path: '/IsSameNowAddress',
    //   component: IsSameNowAddress,
    //   name: IsSameNowAddress
    // },
    {
      path: '/financialBank',
      component: financialBank,
      name: financialBank,
      meta: { requireAuth: true }
    },
    {
      path: '/documentVerifySetEmail',
      component: documentVerifySetEmail,
      name: documentVerifySetEmail
    },
    {
      path: '/corporateNameNumber',
      component: corporateNameNumber,
      name: corporateNameNumber,
      meta: { requireAuth: true }
    },
    {
      path: '/corporateListType',
      component: corporateListType,
      name: corporateListType,
      meta: { requireAuth: true }
    },
    {
      path: '/corporateAddress',
      component: corporateAddress,
      name: corporateAddress,
      meta: { requireAuth: true }
    },
    {
      path: '/representativeTel',
      component: representativeTel,
      name: representativeTel,
      meta: { requireAuth: true }
    },
    {
      path: '/businessContent',
      component: businessContent,
      name: businessContent,
      meta: { requireAuth: true }
    },
    // {
    //   path: '/unqualified',
    //   component: unqualified,
    //   name: unqualified
    // },
    {
      path: '/capitalTaxType',
      component: capitalTaxType,
      name: capitalTaxType,
      meta: { requireAuth: true }
    },
    {
      path: '/dateOfEstablishment',
      component: dateOfEstablishment,
      name: dateOfEstablishment,
      meta: { requireAuth: true }
    },
    {
      path: '/listedCorporationFlg',
      component: listedCorporationFlg,
      name: listedCorporationFlg,
      meta: { requireAuth: true }
    },
    {
      path: '/specifiedCorporationFlg',
      component: specifiedCorporationFlg,
      name: specifiedCorporationFlg,
      meta: { requireAuth: true }
    },
    {
      path: '/representativeInfo',
      component: representativeInfo,
      name: representativeInfo,
      meta: { requireAuth: true }
    },
    {
      path: '/transactionManager',
      component: transactionManager,
      name: transactionManager,
      meta: { requireAuth: true }
    },
    // {
    //   path: '/corporateInsiderFlg',
    //   component: corporateInsiderFlg,
    //   name: corporateInsiderFlg
    // },
    {
      path: '/corporateFundInsiderFlg',
      component: corporateFundInsiderFlg,
      name: corporateFundInsiderFlg,
      meta: { requireAuth: true }
    },
    {
      path: '/corporateQuestionMotiveType',
      component: corporateQuestionMotiveType,
      name: 'corporateQuestionMotiveType',
      meta: { requireAuth: true }
    },
    {
      path: '/corporatePurpose',
      component: corporatePurpose,
      name: 'corporatePurpose',
      meta: { requireAuth: true }
    },
    {
      path: '/corporateFinancialAssts',
      component: corporateFinancialAssts,
      name: 'corporateFinancialAssts',
      meta: { requireAuth: true }
    },
    // {
    //   path: '/corporateAsstsType',
    //   component: corporateAsstsType,
    //   name: 'corporateAsstsTypes'
    // },
    {
      path: '/corporateExperienceStock',
      component: corporateExperienceStock,
      name: 'corporateExperienceStock',
      meta: { requireAuth: true }
    },
    {
      path: '/corporateExperienceDerivative',
      component: corporateExperienceDerivative,
      name: 'corporateExperienceDerivative',
      meta: { requireAuth: true }
    },
    {
      path: '/corporateExperienceFund',
      component: corporateExperienceFund,
      name: 'corporateExperienceFund',
      meta: { requireAuth: true }
    },
    {
      path: '/corporateDesiredInvestmentType',
      component: corporateDesiredInvestmentType,
      name: 'corporateDesiredInvestmentType',
      meta: { requireAuth: true }
    },
    {
      path: '/corporateElectronicDelivery',
      component: corporateElectronicDelivery,
      name: 'corporateElectronicDelivery',
      meta: { requireAuth: true }
    },
    {
      path: '/corporatePersonalInfo',
      component: corporatePersonalInfo,
      name: 'corporatePersonalInfo',
      meta: { requireAuth: true }
    },
    {
      path: '/corporateWithdrawAccount',
      component: corporateWithdrawAccount,
      name: corporateWithdrawAccount,
      meta: { requireAuth: true }
    },
    {
      path: '/corporateAntisocialFlg',
      component: corporateAntisocialFlg,
      name: corporateAntisocialFlg,
      meta: { requireAuth: true }
    },
    {
      path: '/corporateRegulation',
      component: corporateRegulation,
      name: corporateRegulation,
      meta: { requireAuth: true }
    },
    {
      path: '/foreignCountryCompany',
      component: foreignCountryCompany,
      name: foreignCountryCompany,
      meta:{requireAuth:true}
    },
    {
      path: '/corporateLoginPassword',
      component: corporateLoginPassword,
      name: corporateLoginPassword,
      meta:{requireAuth:true}
    },
    {
      path: '/corporateConfirmInfo',
      component: corporateConfirmInfo,
      name: corporateConfirmInfo,
      meta:{requireAuth:true}
    },
    {
      path: '/corporateidentificationGuide',
      component: corporateidentificationGuide,
      name: corporateidentificationGuide
    },
    {
      path: '/rulerInfo',
      component: rulerInfo,
      name: rulerInfo,
      meta: { requireAuth: true }
    },
    // {
    //   path: '/corporateCertificateUpload',
    //   component: corporateCertificateUpload,
    //   name: corporateCertificateUpload
    // },
    {
      path: '/representativeIdentityDocumentsType',
      component: representativeIdentityDocumentsType,
      name: representativeIdentityDocumentsType
    },
    {
      path: '/representativeIdentityDocumentsUpload',
      component: representativeIdentityDocumentsUpload,
      name: representativeIdentityDocumentsUpload
    },
    {
      path: '/transactionManagerIdentityDocumentsType',
      component: transactionManagerIdentityDocumentsType,
      name: transactionManagerIdentityDocumentsType
    },
    {
      path: '/transactionManagerIdentityDocumentsUpload',
      component: transactionManagerIdentityDocumentsUpload,
      name: transactionManagerIdentityDocumentsUpload
    },
    // {
    //   path: '/rulerIdentityDocumentsType',
    //   component: rulerIdentityDocumentsType,
    //   name: rulerIdentityDocumentsType
    // },
    {
      path: '/rulerIdentityDocumentsUpload',
      component: rulerIdentityDocumentsUpload,
      name: rulerIdentityDocumentsUpload
    },
    // {
    //   path: '/documentsUploadDone',
    //   component: documentsUploadDone,
    //   name: documentsUploadDone
    // },
    {
      path: '/subpageflow',
      component: subpageflow,
      name: subpageflow
    },
    {
      path: '/subpageflowcorporate',
      component: subpageflowcorporate,
      name: subpageflowcorporate
    },
    {
      path: '/subpageinsider',
      component: subpageinsider,
      name: subpageinsider
    },
    {
      path: '/subpagetips',
      component: subpagetips,
      name: subpagetips
    },
    {
      path: '/subpagedocument',
      component: subpagedocument,
      name: subpagedocument
    },
    {
      path: '/subpagetokutei',
      component: subpagetokutei,
      name: subpagetokutei
    },
    {
      path: '/peps',
      component: peps,
      name: peps
    },
    {
      path: '/certifyEmail',
      component: certifyEmail,
      name: certifyEmail
    },
    // {
    //   path: '/resetIndex',
    //   component: resetIndex,
    //   name: resetIndex
    // },
    // {
    //   path: '/resetEmail',
    //   component: resetEmail,
    //   name: resetEmail
    // },
    {
      path: '/reset/ConfirmInfo',
      component: resetConfirmInfo,
      name: resetConfirmInfo
    },
    {
      path: '/reset/nameBirthdaySex',
      component: resetNameBirthdaySex,
      name: resetNameBirthdaySex
    },
    // {
    //   path: '/resetNationalty',
    //   component: resetNationalty,
    //   name: resetNationalty
    // },
    {
      path: '/reset/address',
      component: resetAddress,
      name: resetAddress
    },
    {
      path: '/reset/tel',
      component: resetTel,
      name: resetTel
    },
    {
      path: '/reset/identityDocumentsType',
      component: identityDocumentsType,
    },
    // {
    //   path: '/resetIdentityType',
    //   component: resetIdentityType,
    //   name: resetIdentityType
    // },
    // {
    //   path: '/resetMyNumber',
    //   component: resetMyNumber,
    //   name: resetMyNumber
    // },
    {
      path: '/reset/myNumberUpload',
      component: myNumberUpload,
    },
    // {
    //   path: '/resetMyNumberUpload',
    //   component: resetMyNumberUpload,
    //   name: resetMyNumberUpload
    // },
    {
      path: '/reset/onlineConfirm',
      component: onlineConfirm,
    },
    // {
    //   path: '/resetOnlineConfirm',
    //   component: resetOnlineConfirm,
    //   name: resetOnlineConfirm
    // },
    // {
    //   path: '/resetSelfConfirm',
    //   component: resetSelfConfirm,
    //   name: resetSelfConfirm
    // },
    // {
    //   path: '/resetCertificateUpload',
    //   component: resetCertificateUpload,
    //   name: resetCertificateUpload
    // },
    {
      path: '/resetRepresentType',
      component: resetRepresentType,
      name: resetRepresentType
    },
    {
      path: '/resetRepresentUpload',
      component: resetRepresentUpload,
      name: resetRepresentUpload
    },
    {
      path: '/resetTransactionManagerType',
      component: resetTransactionManagerType,
      name: resetTransactionManagerType
    },
    {
      path: '/resetTransactionManagerUpload',
      component: resetTransactionManagerUpload,
      name: resetTransactionManagerUpload
    },
    {
      path: '/resetRulerTypeUpload',
      component: resetRulerTypeUpload,
      name: resetRulerTypeUpload
    },


  ]
})
export default $router;



// WEBPACK FOOTER //
// ./src/router/index.js